import SelectInput from 'CoreComponents/selectInput/';
import { isSamsungBrowser} from 'Utils/browser';

import BookingForm from '../components/bookingForm/';

const SELECTOR = {
  hero: '.hero',
  advanceBookingButton: '.form-booking .form-booking__btn--later',
  categorySelect: '#photographer_category_select',
  introductionBookButton: '.introduction .btn--primary',
  navigationMenuLinks: '.navbar__link'
};

const CATEGORY_SELECT_OPTION = {
  isSearchable: false
};

class HomeScreen {
  constructor() {
    this.advanceBookingButton = document.querySelector(SELECTOR['advanceBookingButton']);
    this.introductionBookButton = document.querySelector(SELECTOR['introductionBookButton']);
    this.navLinks = document.querySelectorAll(SELECTOR['navigationMenuLinks']);

    // Bind Function
    this._clickBookButtonHandler = this._clickBookButtonHandler.bind(this);

    this._setup();
    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Trigger the booking form modal from the introduction section
   *
   * @param {Event} event - click event
   * */
  _clickBookButtonHandler(event) {
    event.preventDefault();

    this.advanceBookingButton.click();
  }

  /**
   * Scroll handler of navLinks.
   *  Finds the closest link clicked.
   *    1) If the href is a hash url, enables smooth scroll.
   *    2) Else allows the default browser action.
   *
   * @param {Event} event - scroll event on navLinks
   * */
  _scrollHandler(event) {
    let closestLink = event.target.closest('a');
    let targetHref = closestLink.hash;

    if ((closestLink.pathname !== window.location.pathname) || (targetHref.indexOf('#') === -1)) { return; }

    event.preventDefault();

    let scrollToEl = document.querySelector(targetHref);

    let appHeader = document.querySelector('.app-header');
    let appHeaderHeight = appHeader.getBoundingClientRect().height;

    // compensate for the header height, as its fixed at top
    let verticalScroll = scrollToEl.getBoundingClientRect().y - appHeaderHeight;

    // Enable Smooth scroll
    window.scrollBy({
      top: verticalScroll,
      left: 0,
      behavior: 'smooth'
    });
  }

  // Private Methods

  _setup() {
    new BookingForm();
    new SelectInput(document.querySelector(SELECTOR['categorySelect']), CATEGORY_SELECT_OPTION);

    isSamsungBrowser() && this._fixBrowserHeightResize();
  }

  /**
   * Binds event listeners.
   * */
  _addEventListeners() {
    this.navLinks.forEach(navLink => navLink.addEventListener('click', this._scrollHandler));

    this.introductionBookButton.addEventListener('click', this._clickBookButtonHandler);
  }

  /**
   * Change the height of the hero to avoid resize issue on scroll
   *
   * See issue: https://www.pivotaltracker.com/story/show/160337836
   * */
  _fixBrowserHeightResize() {
    const heroElement = document.querySelector(SELECTOR['hero']);

    heroElement.style.height = `${document.documentElement.clientHeight - 54}px`;
  }
}

// Setup the HomeScreen class, only on landing page.
let isHomePage = document.body.classList.contains('home') && document.body.classList.contains('index');

if (isHomePage) {
  new HomeScreen();
}



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/Home.js